import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './LegalPage.css';

const PAGES = {
  privacy: {
    title: 'Privacy',
    lede: 'How Laurenti Apparel handles the information you share with the house.',
    body: [
      'We collect account details, order information, and basic site preferences needed to run the shop.',
      'Payment card data is never stored on our servers once a payment provider is connected — checkout will process through that provider’s secure flow.',
      'We do not sell personal data. Analytics, if enabled later, will only run after you accept cookies.',
      'Questions: use the email published in store settings or contact support from your order confirmation.',
    ],
  },
  terms: {
    title: 'Terms',
    lede: 'The ground rules for shopping with Laurenti Apparel.',
    body: [
      'Products are offered while stock lasts. Placing an order requests that stock; inventory is reserved when checkout completes successfully.',
      'Prices are shown in your selected currency as an estimate converted from our base catalogue pricing.',
      'Licensed apparel authenticity claims apply to goods we list as officially licensed.',
      'These terms will be updated when payment, shipping carriers, and returns partners are finalized.',
    ],
  },
  shipping: {
    title: 'Shipping',
    lede: 'How orders leave the house.',
    body: [
      'Shipping is calculated from store shipping settings (flat rate, with an optional free-shipping threshold).',
      'Delivery windows depend on your region and the fulfilment partner we use for each order.',
      'You will receive tracking when a carrier label is created — that integration is designed in checkout and wired when fulfilment goes live.',
      'International duties or taxes may apply depending on your destination.',
    ],
  },
  returns: {
    title: 'Returns',
    lede: 'If a piece is not right.',
    body: [
      'Unworn items in original condition may be returned within the window published at fulfilment time.',
      'Personalized or clearly final-sale pieces will be marked on the product page when that policy applies.',
      'Start a return from your order history once the returns workflow is connected to our warehouse.',
      'Until then, contact support with your order number and we will handle it manually.',
    ],
  },
};

function LegalPage() {
  const location = useLocation();
  const slug = location.pathname.replace(/^\//, '').split('/')[0];
  const page = PAGES[slug];

  if (!page) {
    return (
      <div className="legal-page">
        <p className="store-eyebrow">House</p>
        <h1 className="store-title">Page not found</h1>
        <Link to="/" className="store-link">
          Back home
        </Link>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <p className="store-eyebrow">House</p>
      <h1 className="store-title">{page.title}</h1>
      <p className="store-lede">{page.lede}</p>
      <div className="legal-body">
        {page.body.map(paragraph => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
}

export default LegalPage;
